import {
  Circle,
  Defs,
  G,
  LinearGradient,
  Mask,
  Path,
  Rect,
  Stop,
  Svg,
} from 'react-native-svg';

export function TaxDownLogoAsset({
  width = 127,
  height = 94,
  className,
}: TTaxDownLogoAssetProps) {
  return (
    <Svg width={width} height={height} className={className} fill="none">
      <Path
        fill="url(#a)"
        d="M119.479 5.411 104.068-10 71.177 22.891l15.41 15.411L119.48 5.411Z"
        opacity={0.6}
      />
      <Path
        fill="#fff"
        d="M19 21.673C19 14.122 25.122 8 32.673 8h60.654C100.878 8 107 14.122 107 21.673V104H19V21.673Z"
      />
      <Path
        fill="#393963"
        d="M18 43.715h.612v6.735H18zM18 57.183h.612v13.469H18zM18 74.732h.612v13.469H18zM107.388 66.571h.408c.113 0 .204.092.204.204V88a.204.204 0 0 1-.204.204h-.408V66.57Z"
      />
      <Path
        stroke="#393963"
        strokeWidth={2}
        d="M18.612 104V21.673C18.612 14.122 24.734 8 32.286 8h61.428c7.552 0 13.674 6.122 13.674 13.673V104"
      />
      <Rect width={12} height={2} x={55} y={15} fill="#3B3861" rx={1} />
      <Circle cx={71} cy={16} r={1} fill="#3B3861" />
      <Path
        fill="url(#b)"
        d="m43.418 70.334-14.181-14.18L0 85.39l14.181 14.18 29.237-29.236Z"
        opacity={0.6}
      />
      <Path
        fill="url(#c)"
        d="m80.997 85.945 12.79 12.791 32.892-32.89-12.791-12.792-32.891 32.891Z"
        opacity={0.6}
      />
      <Mask
        id="d"
        width={58}
        height={38}
        x={36}
        y={38}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <Path fill="#fff" d="M93.31 38.97H36.548v36.823H93.31V38.971Z" />
      </Mask>
      <G fill="#0FD48E" mask="url(#d)">
        <Path d="M52.855 47.896 44.7 39.797l-8.153 8.1 8.153 8.099 8.154-8.1ZM72.784 47.895l-8.153-8.099-18.119 17.998 8.154 8.1 18.118-17.999ZM92.718 47.895l-8.154-8.099-28.083 27.897 8.153 8.1 28.084-27.898Z" />
      </G>
      <Defs>
        <LinearGradient
          id="a"
          x1={95.314}
          x2={111.174}
          y1={14.116}
          y2={-2.338}
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset={0.445} stopColor="#62C8AF" />
          <Stop offset={1} stopColor="#fff" stopOpacity={0} />
        </LinearGradient>
        <LinearGradient
          id="b"
          x1={7.11}
          x2={36.86}
          y1={91.759}
          y2={62.932}
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset={0.335} stopColor="#5A74D0" />
          <Stop offset={1} stopColor="#fff" stopOpacity={0} />
        </LinearGradient>
        <LinearGradient
          id="c"
          x1={120.183}
          x2={86.59}
          y1={60.183}
          y2={92.481}
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset={0.255} stopColor="#FF7F63" />
          <Stop offset={1} stopColor="#fff" stopOpacity={0} />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export type TTaxDownLogoAssetProps = {
  width?: number;
  height?: number;
  className?: string;
};
